import { render, staticRenderFns } from "./serviceprovidersform.vue?vue&type=template&id=21571d39&"
import script from "./serviceprovidersform.vue?vue&type=script&lang=ts&"
export * from "./serviceprovidersform.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports